import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { withLayout } from "../../components/layout/Layout";

import { isMultipleUserLevel } from "../../store/account";
import { isSBReportingLicensed } from "../../store/settings/settings.selectors";

import { Dashboard } from "./Dashboard";
import { Devices } from "./devices/DevicesOnHome";
import { AriaPageTitle } from "../../components/ariaPageTitle";
import { useRemoteReminderBanner } from "../../components/notification/hooks/useRemoteReminderBanner";
import { useShowRemoteReminderDialog } from "../../components/spsonReminderDialog/SpsonReminderDialog";
import { fetchLogicalDevices } from "../../store/devices/logicalDevices";

const HomePageContent = () => {
  const dispatch = useDispatch();
  const isMultiple = useSelector(isMultipleUserLevel);
  const isLicensed = useSelector(isSBReportingLicensed);

  useEffect(() => {
    dispatch(fetchLogicalDevices());
  });

  useRemoteReminderBanner();
  useShowRemoteReminderDialog();

  if (!isLicensed && !isMultiple) return <Navigate to="/settings" />;

  return (
    <section className="home-page">
      <AriaPageTitle pageKey={"page_title_home_page"} />
      {isLicensed && <Dashboard />}
      {isMultiple && <Devices />}
    </section>
  );
};

export const HomePage = withLayout()(HomePageContent);
